exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".button-placeholder{padding-top:3px}.min-price{color:darkred}div.price-analysis-dt table>tbody>tr,div.price-analysis-dt table>thead>tr{font-size:90%}.gap-placeholder{text-decoration:underline;background-color:#e6ad9f;display:inline-block;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-2deba21d!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PriceAnalysis/detail.vue
// module id = 863
// module chunks = 2